/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WawasanProductRouteImport } from './routes/wawasan-product'
import { Route as WawasanRouteImport } from './routes/wawasan'
import { Route as SuperadminRouteImport } from './routes/superadmin'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as RekrutProductRouteImport } from './routes/rekrut-product'
import { Route as RekrutRouteImport } from './routes/rekrut'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as OrgRouteImport } from './routes/org'
import { Route as LoginRouteImport } from './routes/login'
import { Route as KinerjaProductRouteImport } from './routes/kinerja-product'
import { Route as KinerjaRouteImport } from './routes/kinerja'
import { Route as IdpRouteImport } from './routes/idp'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WawasanIndexRouteImport } from './routes/wawasan/index'
import { Route as RekrutIndexRouteImport } from './routes/rekrut/index'
import { Route as OrgIndexRouteImport } from './routes/org/index'
import { Route as KinerjaIndexRouteImport } from './routes/kinerja/index'
import { Route as Wawasan9boxRouteImport } from './routes/wawasan/9box'
import { Route as RekrutPipelineRouteImport } from './routes/rekrut/pipeline'
import { Route as RekrutJobsRouteImport } from './routes/rekrut/jobs'
import { Route as RekrutCandidatesRouteImport } from './routes/rekrut/candidates'
import { Route as KinerjaTrainingCatalogueRouteImport } from './routes/kinerja/training-catalogue'
import { Route as KinerjaTemplatesRouteImport } from './routes/kinerja/templates'
import { Route as KinerjaPsychometricsRouteImport } from './routes/kinerja/psychometrics'
import { Route as KinerjaPositionsRouteImport } from './routes/kinerja/positions'
import { Route as KinerjaOrgLevelsRouteImport } from './routes/kinerja/org-levels'
import { Route as KinerjaMyAssessmentsRouteImport } from './routes/kinerja/my-assessments'
import { Route as KinerjaMilestoneTemplatesRouteImport } from './routes/kinerja/milestone-templates'
import { Route as KinerjaMetricsRouteImport } from './routes/kinerja/metrics'
import { Route as KinerjaMetricWeightsRouteImport } from './routes/kinerja/metric-weights'
import { Route as KinerjaCompetenciesRouteImport } from './routes/kinerja/competencies'
import { Route as KinerjaAssessmentsRouteImport } from './routes/kinerja/assessments'
import { Route as RekrutJobsIndexRouteImport } from './routes/rekrut/jobs.index'
import { Route as RekrutCandidatesIndexRouteImport } from './routes/rekrut/candidates.index'
import { Route as KinerjaTasksIndexRouteImport } from './routes/kinerja/tasks/index'
import { Route as RekrutJobsJobIdRouteImport } from './routes/rekrut/jobs.$jobId'
import { Route as RekrutCandidatesCandidateIdRouteImport } from './routes/rekrut/candidates.$candidateId'
import { Route as OrgEmployeesEmployeeIdRouteImport } from './routes/org/employees.$employeeId'
import { Route as KinerjaTemplatesTemplateIdRouteImport } from './routes/kinerja/templates.$templateId'
import { Route as KinerjaAssessmentsSessionIdRouteImport } from './routes/kinerja/assessments.$sessionId'
import { Route as KinerjaTasksSprintsSprintIdRouteImport } from './routes/kinerja/tasks/sprints.$sprintId'
import { Route as KinerjaTasksProjectsProjectIdRouteImport } from './routes/kinerja/tasks/projects.$projectId'
import { Route as KinerjaPsychometricsTestIdTakeRouteImport } from './routes/kinerja/psychometrics.$testId.take'
import { Route as KinerjaPsychometricsTestIdEditRouteImport } from './routes/kinerja/psychometrics.$testId.edit'
import { Route as KinerjaTasksSprintsSprintIdSummaryRouteImport } from './routes/kinerja/tasks/sprints.$sprintId_.summary'

const WawasanProductRoute = WawasanProductRouteImport.update({
  id: '/wawasan-product',
  path: '/wawasan-product',
  getParentRoute: () => rootRouteImport,
} as any)
const WawasanRoute = WawasanRouteImport.update({
  id: '/wawasan',
  path: '/wawasan',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperadminRoute = SuperadminRouteImport.update({
  id: '/superadmin',
  path: '/superadmin',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const RekrutProductRoute = RekrutProductRouteImport.update({
  id: '/rekrut-product',
  path: '/rekrut-product',
  getParentRoute: () => rootRouteImport,
} as any)
const RekrutRoute = RekrutRouteImport.update({
  id: '/rekrut',
  path: '/rekrut',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgRoute = OrgRouteImport.update({
  id: '/org',
  path: '/org',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const KinerjaProductRoute = KinerjaProductRouteImport.update({
  id: '/kinerja-product',
  path: '/kinerja-product',
  getParentRoute: () => rootRouteImport,
} as any)
const KinerjaRoute = KinerjaRouteImport.update({
  id: '/kinerja',
  path: '/kinerja',
  getParentRoute: () => rootRouteImport,
} as any)
const IdpRoute = IdpRouteImport.update({
  id: '/idp',
  path: '/idp',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WawasanIndexRoute = WawasanIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WawasanRoute,
} as any)
const RekrutIndexRoute = RekrutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RekrutRoute,
} as any)
const OrgIndexRoute = OrgIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgRoute,
} as any)
const KinerjaIndexRoute = KinerjaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => KinerjaRoute,
} as any)
const Wawasan9boxRoute = Wawasan9boxRouteImport.update({
  id: '/9box',
  path: '/9box',
  getParentRoute: () => WawasanRoute,
} as any)
const RekrutPipelineRoute = RekrutPipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => RekrutRoute,
} as any)
const RekrutJobsRoute = RekrutJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => RekrutRoute,
} as any)
const RekrutCandidatesRoute = RekrutCandidatesRouteImport.update({
  id: '/candidates',
  path: '/candidates',
  getParentRoute: () => RekrutRoute,
} as any)
const KinerjaTrainingCatalogueRoute =
  KinerjaTrainingCatalogueRouteImport.update({
    id: '/training-catalogue',
    path: '/training-catalogue',
    getParentRoute: () => KinerjaRoute,
  } as any)
const KinerjaTemplatesRoute = KinerjaTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => KinerjaRoute,
} as any)
const KinerjaPsychometricsRoute = KinerjaPsychometricsRouteImport.update({
  id: '/psychometrics',
  path: '/psychometrics',
  getParentRoute: () => KinerjaRoute,
} as any)
const KinerjaPositionsRoute = KinerjaPositionsRouteImport.update({
  id: '/positions',
  path: '/positions',
  getParentRoute: () => KinerjaRoute,
} as any)
const KinerjaOrgLevelsRoute = KinerjaOrgLevelsRouteImport.update({
  id: '/org-levels',
  path: '/org-levels',
  getParentRoute: () => KinerjaRoute,
} as any)
const KinerjaMyAssessmentsRoute = KinerjaMyAssessmentsRouteImport.update({
  id: '/my-assessments',
  path: '/my-assessments',
  getParentRoute: () => KinerjaRoute,
} as any)
const KinerjaMilestoneTemplatesRoute =
  KinerjaMilestoneTemplatesRouteImport.update({
    id: '/milestone-templates',
    path: '/milestone-templates',
    getParentRoute: () => KinerjaRoute,
  } as any)
const KinerjaMetricsRoute = KinerjaMetricsRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => KinerjaRoute,
} as any)
const KinerjaMetricWeightsRoute = KinerjaMetricWeightsRouteImport.update({
  id: '/metric-weights',
  path: '/metric-weights',
  getParentRoute: () => KinerjaRoute,
} as any)
const KinerjaCompetenciesRoute = KinerjaCompetenciesRouteImport.update({
  id: '/competencies',
  path: '/competencies',
  getParentRoute: () => KinerjaRoute,
} as any)
const KinerjaAssessmentsRoute = KinerjaAssessmentsRouteImport.update({
  id: '/assessments',
  path: '/assessments',
  getParentRoute: () => KinerjaRoute,
} as any)
const RekrutJobsIndexRoute = RekrutJobsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RekrutJobsRoute,
} as any)
const RekrutCandidatesIndexRoute = RekrutCandidatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RekrutCandidatesRoute,
} as any)
const KinerjaTasksIndexRoute = KinerjaTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => KinerjaRoute,
} as any)
const RekrutJobsJobIdRoute = RekrutJobsJobIdRouteImport.update({
  id: '/$jobId',
  path: '/$jobId',
  getParentRoute: () => RekrutJobsRoute,
} as any)
const RekrutCandidatesCandidateIdRoute =
  RekrutCandidatesCandidateIdRouteImport.update({
    id: '/$candidateId',
    path: '/$candidateId',
    getParentRoute: () => RekrutCandidatesRoute,
  } as any)
const OrgEmployeesEmployeeIdRoute = OrgEmployeesEmployeeIdRouteImport.update({
  id: '/employees/$employeeId',
  path: '/employees/$employeeId',
  getParentRoute: () => OrgRoute,
} as any)
const KinerjaTemplatesTemplateIdRoute =
  KinerjaTemplatesTemplateIdRouteImport.update({
    id: '/$templateId',
    path: '/$templateId',
    getParentRoute: () => KinerjaTemplatesRoute,
  } as any)
const KinerjaAssessmentsSessionIdRoute =
  KinerjaAssessmentsSessionIdRouteImport.update({
    id: '/$sessionId',
    path: '/$sessionId',
    getParentRoute: () => KinerjaAssessmentsRoute,
  } as any)
const KinerjaTasksSprintsSprintIdRoute =
  KinerjaTasksSprintsSprintIdRouteImport.update({
    id: '/tasks/sprints/$sprintId',
    path: '/tasks/sprints/$sprintId',
    getParentRoute: () => KinerjaRoute,
  } as any)
const KinerjaTasksProjectsProjectIdRoute =
  KinerjaTasksProjectsProjectIdRouteImport.update({
    id: '/tasks/projects/$projectId',
    path: '/tasks/projects/$projectId',
    getParentRoute: () => KinerjaRoute,
  } as any)
const KinerjaPsychometricsTestIdTakeRoute =
  KinerjaPsychometricsTestIdTakeRouteImport.update({
    id: '/$testId/take',
    path: '/$testId/take',
    getParentRoute: () => KinerjaPsychometricsRoute,
  } as any)
const KinerjaPsychometricsTestIdEditRoute =
  KinerjaPsychometricsTestIdEditRouteImport.update({
    id: '/$testId/edit',
    path: '/$testId/edit',
    getParentRoute: () => KinerjaPsychometricsRoute,
  } as any)
const KinerjaTasksSprintsSprintIdSummaryRoute =
  KinerjaTasksSprintsSprintIdSummaryRouteImport.update({
    id: '/tasks/sprints/$sprintId_/summary',
    path: '/tasks/sprints/$sprintId/summary',
    getParentRoute: () => KinerjaRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/dashboard': typeof DashboardRoute
  '/idp': typeof IdpRoute
  '/kinerja': typeof KinerjaRouteWithChildren
  '/kinerja-product': typeof KinerjaProductRoute
  '/login': typeof LoginRoute
  '/org': typeof OrgRouteWithChildren
  '/profile': typeof ProfileRoute
  '/rekrut': typeof RekrutRouteWithChildren
  '/rekrut-product': typeof RekrutProductRoute
  '/reports': typeof ReportsRoute
  '/superadmin': typeof SuperadminRoute
  '/wawasan': typeof WawasanRouteWithChildren
  '/wawasan-product': typeof WawasanProductRoute
  '/kinerja/assessments': typeof KinerjaAssessmentsRouteWithChildren
  '/kinerja/competencies': typeof KinerjaCompetenciesRoute
  '/kinerja/metric-weights': typeof KinerjaMetricWeightsRoute
  '/kinerja/metrics': typeof KinerjaMetricsRoute
  '/kinerja/milestone-templates': typeof KinerjaMilestoneTemplatesRoute
  '/kinerja/my-assessments': typeof KinerjaMyAssessmentsRoute
  '/kinerja/org-levels': typeof KinerjaOrgLevelsRoute
  '/kinerja/positions': typeof KinerjaPositionsRoute
  '/kinerja/psychometrics': typeof KinerjaPsychometricsRouteWithChildren
  '/kinerja/templates': typeof KinerjaTemplatesRouteWithChildren
  '/kinerja/training-catalogue': typeof KinerjaTrainingCatalogueRoute
  '/rekrut/candidates': typeof RekrutCandidatesRouteWithChildren
  '/rekrut/jobs': typeof RekrutJobsRouteWithChildren
  '/rekrut/pipeline': typeof RekrutPipelineRoute
  '/wawasan/9box': typeof Wawasan9boxRoute
  '/kinerja/': typeof KinerjaIndexRoute
  '/org/': typeof OrgIndexRoute
  '/rekrut/': typeof RekrutIndexRoute
  '/wawasan/': typeof WawasanIndexRoute
  '/kinerja/assessments/$sessionId': typeof KinerjaAssessmentsSessionIdRoute
  '/kinerja/templates/$templateId': typeof KinerjaTemplatesTemplateIdRoute
  '/org/employees/$employeeId': typeof OrgEmployeesEmployeeIdRoute
  '/rekrut/candidates/$candidateId': typeof RekrutCandidatesCandidateIdRoute
  '/rekrut/jobs/$jobId': typeof RekrutJobsJobIdRoute
  '/kinerja/tasks/': typeof KinerjaTasksIndexRoute
  '/rekrut/candidates/': typeof RekrutCandidatesIndexRoute
  '/rekrut/jobs/': typeof RekrutJobsIndexRoute
  '/kinerja/psychometrics/$testId/edit': typeof KinerjaPsychometricsTestIdEditRoute
  '/kinerja/psychometrics/$testId/take': typeof KinerjaPsychometricsTestIdTakeRoute
  '/kinerja/tasks/projects/$projectId': typeof KinerjaTasksProjectsProjectIdRoute
  '/kinerja/tasks/sprints/$sprintId': typeof KinerjaTasksSprintsSprintIdRoute
  '/kinerja/tasks/sprints/$sprintId/summary': typeof KinerjaTasksSprintsSprintIdSummaryRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/dashboard': typeof DashboardRoute
  '/idp': typeof IdpRoute
  '/kinerja-product': typeof KinerjaProductRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/rekrut-product': typeof RekrutProductRoute
  '/reports': typeof ReportsRoute
  '/superadmin': typeof SuperadminRoute
  '/wawasan-product': typeof WawasanProductRoute
  '/kinerja/assessments': typeof KinerjaAssessmentsRouteWithChildren
  '/kinerja/competencies': typeof KinerjaCompetenciesRoute
  '/kinerja/metric-weights': typeof KinerjaMetricWeightsRoute
  '/kinerja/metrics': typeof KinerjaMetricsRoute
  '/kinerja/milestone-templates': typeof KinerjaMilestoneTemplatesRoute
  '/kinerja/my-assessments': typeof KinerjaMyAssessmentsRoute
  '/kinerja/org-levels': typeof KinerjaOrgLevelsRoute
  '/kinerja/positions': typeof KinerjaPositionsRoute
  '/kinerja/psychometrics': typeof KinerjaPsychometricsRouteWithChildren
  '/kinerja/templates': typeof KinerjaTemplatesRouteWithChildren
  '/kinerja/training-catalogue': typeof KinerjaTrainingCatalogueRoute
  '/rekrut/pipeline': typeof RekrutPipelineRoute
  '/wawasan/9box': typeof Wawasan9boxRoute
  '/kinerja': typeof KinerjaIndexRoute
  '/org': typeof OrgIndexRoute
  '/rekrut': typeof RekrutIndexRoute
  '/wawasan': typeof WawasanIndexRoute
  '/kinerja/assessments/$sessionId': typeof KinerjaAssessmentsSessionIdRoute
  '/kinerja/templates/$templateId': typeof KinerjaTemplatesTemplateIdRoute
  '/org/employees/$employeeId': typeof OrgEmployeesEmployeeIdRoute
  '/rekrut/candidates/$candidateId': typeof RekrutCandidatesCandidateIdRoute
  '/rekrut/jobs/$jobId': typeof RekrutJobsJobIdRoute
  '/kinerja/tasks': typeof KinerjaTasksIndexRoute
  '/rekrut/candidates': typeof RekrutCandidatesIndexRoute
  '/rekrut/jobs': typeof RekrutJobsIndexRoute
  '/kinerja/psychometrics/$testId/edit': typeof KinerjaPsychometricsTestIdEditRoute
  '/kinerja/psychometrics/$testId/take': typeof KinerjaPsychometricsTestIdTakeRoute
  '/kinerja/tasks/projects/$projectId': typeof KinerjaTasksProjectsProjectIdRoute
  '/kinerja/tasks/sprints/$sprintId': typeof KinerjaTasksSprintsSprintIdRoute
  '/kinerja/tasks/sprints/$sprintId/summary': typeof KinerjaTasksSprintsSprintIdSummaryRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/dashboard': typeof DashboardRoute
  '/idp': typeof IdpRoute
  '/kinerja': typeof KinerjaRouteWithChildren
  '/kinerja-product': typeof KinerjaProductRoute
  '/login': typeof LoginRoute
  '/org': typeof OrgRouteWithChildren
  '/profile': typeof ProfileRoute
  '/rekrut': typeof RekrutRouteWithChildren
  '/rekrut-product': typeof RekrutProductRoute
  '/reports': typeof ReportsRoute
  '/superadmin': typeof SuperadminRoute
  '/wawasan': typeof WawasanRouteWithChildren
  '/wawasan-product': typeof WawasanProductRoute
  '/kinerja/assessments': typeof KinerjaAssessmentsRouteWithChildren
  '/kinerja/competencies': typeof KinerjaCompetenciesRoute
  '/kinerja/metric-weights': typeof KinerjaMetricWeightsRoute
  '/kinerja/metrics': typeof KinerjaMetricsRoute
  '/kinerja/milestone-templates': typeof KinerjaMilestoneTemplatesRoute
  '/kinerja/my-assessments': typeof KinerjaMyAssessmentsRoute
  '/kinerja/org-levels': typeof KinerjaOrgLevelsRoute
  '/kinerja/positions': typeof KinerjaPositionsRoute
  '/kinerja/psychometrics': typeof KinerjaPsychometricsRouteWithChildren
  '/kinerja/templates': typeof KinerjaTemplatesRouteWithChildren
  '/kinerja/training-catalogue': typeof KinerjaTrainingCatalogueRoute
  '/rekrut/candidates': typeof RekrutCandidatesRouteWithChildren
  '/rekrut/jobs': typeof RekrutJobsRouteWithChildren
  '/rekrut/pipeline': typeof RekrutPipelineRoute
  '/wawasan/9box': typeof Wawasan9boxRoute
  '/kinerja/': typeof KinerjaIndexRoute
  '/org/': typeof OrgIndexRoute
  '/rekrut/': typeof RekrutIndexRoute
  '/wawasan/': typeof WawasanIndexRoute
  '/kinerja/assessments/$sessionId': typeof KinerjaAssessmentsSessionIdRoute
  '/kinerja/templates/$templateId': typeof KinerjaTemplatesTemplateIdRoute
  '/org/employees/$employeeId': typeof OrgEmployeesEmployeeIdRoute
  '/rekrut/candidates/$candidateId': typeof RekrutCandidatesCandidateIdRoute
  '/rekrut/jobs/$jobId': typeof RekrutJobsJobIdRoute
  '/kinerja/tasks/': typeof KinerjaTasksIndexRoute
  '/rekrut/candidates/': typeof RekrutCandidatesIndexRoute
  '/rekrut/jobs/': typeof RekrutJobsIndexRoute
  '/kinerja/psychometrics/$testId/edit': typeof KinerjaPsychometricsTestIdEditRoute
  '/kinerja/psychometrics/$testId/take': typeof KinerjaPsychometricsTestIdTakeRoute
  '/kinerja/tasks/projects/$projectId': typeof KinerjaTasksProjectsProjectIdRoute
  '/kinerja/tasks/sprints/$sprintId': typeof KinerjaTasksSprintsSprintIdRoute
  '/kinerja/tasks/sprints/$sprintId_/summary': typeof KinerjaTasksSprintsSprintIdSummaryRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/dashboard'
    | '/idp'
    | '/kinerja'
    | '/kinerja-product'
    | '/login'
    | '/org'
    | '/profile'
    | '/rekrut'
    | '/rekrut-product'
    | '/reports'
    | '/superadmin'
    | '/wawasan'
    | '/wawasan-product'
    | '/kinerja/assessments'
    | '/kinerja/competencies'
    | '/kinerja/metric-weights'
    | '/kinerja/metrics'
    | '/kinerja/milestone-templates'
    | '/kinerja/my-assessments'
    | '/kinerja/org-levels'
    | '/kinerja/positions'
    | '/kinerja/psychometrics'
    | '/kinerja/templates'
    | '/kinerja/training-catalogue'
    | '/rekrut/candidates'
    | '/rekrut/jobs'
    | '/rekrut/pipeline'
    | '/wawasan/9box'
    | '/kinerja/'
    | '/org/'
    | '/rekrut/'
    | '/wawasan/'
    | '/kinerja/assessments/$sessionId'
    | '/kinerja/templates/$templateId'
    | '/org/employees/$employeeId'
    | '/rekrut/candidates/$candidateId'
    | '/rekrut/jobs/$jobId'
    | '/kinerja/tasks/'
    | '/rekrut/candidates/'
    | '/rekrut/jobs/'
    | '/kinerja/psychometrics/$testId/edit'
    | '/kinerja/psychometrics/$testId/take'
    | '/kinerja/tasks/projects/$projectId'
    | '/kinerja/tasks/sprints/$sprintId'
    | '/kinerja/tasks/sprints/$sprintId/summary'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/dashboard'
    | '/idp'
    | '/kinerja-product'
    | '/login'
    | '/profile'
    | '/rekrut-product'
    | '/reports'
    | '/superadmin'
    | '/wawasan-product'
    | '/kinerja/assessments'
    | '/kinerja/competencies'
    | '/kinerja/metric-weights'
    | '/kinerja/metrics'
    | '/kinerja/milestone-templates'
    | '/kinerja/my-assessments'
    | '/kinerja/org-levels'
    | '/kinerja/positions'
    | '/kinerja/psychometrics'
    | '/kinerja/templates'
    | '/kinerja/training-catalogue'
    | '/rekrut/pipeline'
    | '/wawasan/9box'
    | '/kinerja'
    | '/org'
    | '/rekrut'
    | '/wawasan'
    | '/kinerja/assessments/$sessionId'
    | '/kinerja/templates/$templateId'
    | '/org/employees/$employeeId'
    | '/rekrut/candidates/$candidateId'
    | '/rekrut/jobs/$jobId'
    | '/kinerja/tasks'
    | '/rekrut/candidates'
    | '/rekrut/jobs'
    | '/kinerja/psychometrics/$testId/edit'
    | '/kinerja/psychometrics/$testId/take'
    | '/kinerja/tasks/projects/$projectId'
    | '/kinerja/tasks/sprints/$sprintId'
    | '/kinerja/tasks/sprints/$sprintId/summary'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/dashboard'
    | '/idp'
    | '/kinerja'
    | '/kinerja-product'
    | '/login'
    | '/org'
    | '/profile'
    | '/rekrut'
    | '/rekrut-product'
    | '/reports'
    | '/superadmin'
    | '/wawasan'
    | '/wawasan-product'
    | '/kinerja/assessments'
    | '/kinerja/competencies'
    | '/kinerja/metric-weights'
    | '/kinerja/metrics'
    | '/kinerja/milestone-templates'
    | '/kinerja/my-assessments'
    | '/kinerja/org-levels'
    | '/kinerja/positions'
    | '/kinerja/psychometrics'
    | '/kinerja/templates'
    | '/kinerja/training-catalogue'
    | '/rekrut/candidates'
    | '/rekrut/jobs'
    | '/rekrut/pipeline'
    | '/wawasan/9box'
    | '/kinerja/'
    | '/org/'
    | '/rekrut/'
    | '/wawasan/'
    | '/kinerja/assessments/$sessionId'
    | '/kinerja/templates/$templateId'
    | '/org/employees/$employeeId'
    | '/rekrut/candidates/$candidateId'
    | '/rekrut/jobs/$jobId'
    | '/kinerja/tasks/'
    | '/rekrut/candidates/'
    | '/rekrut/jobs/'
    | '/kinerja/psychometrics/$testId/edit'
    | '/kinerja/psychometrics/$testId/take'
    | '/kinerja/tasks/projects/$projectId'
    | '/kinerja/tasks/sprints/$sprintId'
    | '/kinerja/tasks/sprints/$sprintId_/summary'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  DashboardRoute: typeof DashboardRoute
  IdpRoute: typeof IdpRoute
  KinerjaRoute: typeof KinerjaRouteWithChildren
  KinerjaProductRoute: typeof KinerjaProductRoute
  LoginRoute: typeof LoginRoute
  OrgRoute: typeof OrgRouteWithChildren
  ProfileRoute: typeof ProfileRoute
  RekrutRoute: typeof RekrutRouteWithChildren
  RekrutProductRoute: typeof RekrutProductRoute
  ReportsRoute: typeof ReportsRoute
  SuperadminRoute: typeof SuperadminRoute
  WawasanRoute: typeof WawasanRouteWithChildren
  WawasanProductRoute: typeof WawasanProductRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/wawasan-product': {
      id: '/wawasan-product'
      path: '/wawasan-product'
      fullPath: '/wawasan-product'
      preLoaderRoute: typeof WawasanProductRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wawasan': {
      id: '/wawasan'
      path: '/wawasan'
      fullPath: '/wawasan'
      preLoaderRoute: typeof WawasanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/superadmin': {
      id: '/superadmin'
      path: '/superadmin'
      fullPath: '/superadmin'
      preLoaderRoute: typeof SuperadminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rekrut-product': {
      id: '/rekrut-product'
      path: '/rekrut-product'
      fullPath: '/rekrut-product'
      preLoaderRoute: typeof RekrutProductRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rekrut': {
      id: '/rekrut'
      path: '/rekrut'
      fullPath: '/rekrut'
      preLoaderRoute: typeof RekrutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org': {
      id: '/org'
      path: '/org'
      fullPath: '/org'
      preLoaderRoute: typeof OrgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kinerja-product': {
      id: '/kinerja-product'
      path: '/kinerja-product'
      fullPath: '/kinerja-product'
      preLoaderRoute: typeof KinerjaProductRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kinerja': {
      id: '/kinerja'
      path: '/kinerja'
      fullPath: '/kinerja'
      preLoaderRoute: typeof KinerjaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/idp': {
      id: '/idp'
      path: '/idp'
      fullPath: '/idp'
      preLoaderRoute: typeof IdpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wawasan/': {
      id: '/wawasan/'
      path: '/'
      fullPath: '/wawasan/'
      preLoaderRoute: typeof WawasanIndexRouteImport
      parentRoute: typeof WawasanRoute
    }
    '/rekrut/': {
      id: '/rekrut/'
      path: '/'
      fullPath: '/rekrut/'
      preLoaderRoute: typeof RekrutIndexRouteImport
      parentRoute: typeof RekrutRoute
    }
    '/org/': {
      id: '/org/'
      path: '/'
      fullPath: '/org/'
      preLoaderRoute: typeof OrgIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/kinerja/': {
      id: '/kinerja/'
      path: '/'
      fullPath: '/kinerja/'
      preLoaderRoute: typeof KinerjaIndexRouteImport
      parentRoute: typeof KinerjaRoute
    }
    '/wawasan/9box': {
      id: '/wawasan/9box'
      path: '/9box'
      fullPath: '/wawasan/9box'
      preLoaderRoute: typeof Wawasan9boxRouteImport
      parentRoute: typeof WawasanRoute
    }
    '/rekrut/pipeline': {
      id: '/rekrut/pipeline'
      path: '/pipeline'
      fullPath: '/rekrut/pipeline'
      preLoaderRoute: typeof RekrutPipelineRouteImport
      parentRoute: typeof RekrutRoute
    }
    '/rekrut/jobs': {
      id: '/rekrut/jobs'
      path: '/jobs'
      fullPath: '/rekrut/jobs'
      preLoaderRoute: typeof RekrutJobsRouteImport
      parentRoute: typeof RekrutRoute
    }
    '/rekrut/candidates': {
      id: '/rekrut/candidates'
      path: '/candidates'
      fullPath: '/rekrut/candidates'
      preLoaderRoute: typeof RekrutCandidatesRouteImport
      parentRoute: typeof RekrutRoute
    }
    '/kinerja/training-catalogue': {
      id: '/kinerja/training-catalogue'
      path: '/training-catalogue'
      fullPath: '/kinerja/training-catalogue'
      preLoaderRoute: typeof KinerjaTrainingCatalogueRouteImport
      parentRoute: typeof KinerjaRoute
    }
    '/kinerja/templates': {
      id: '/kinerja/templates'
      path: '/templates'
      fullPath: '/kinerja/templates'
      preLoaderRoute: typeof KinerjaTemplatesRouteImport
      parentRoute: typeof KinerjaRoute
    }
    '/kinerja/psychometrics': {
      id: '/kinerja/psychometrics'
      path: '/psychometrics'
      fullPath: '/kinerja/psychometrics'
      preLoaderRoute: typeof KinerjaPsychometricsRouteImport
      parentRoute: typeof KinerjaRoute
    }
    '/kinerja/positions': {
      id: '/kinerja/positions'
      path: '/positions'
      fullPath: '/kinerja/positions'
      preLoaderRoute: typeof KinerjaPositionsRouteImport
      parentRoute: typeof KinerjaRoute
    }
    '/kinerja/org-levels': {
      id: '/kinerja/org-levels'
      path: '/org-levels'
      fullPath: '/kinerja/org-levels'
      preLoaderRoute: typeof KinerjaOrgLevelsRouteImport
      parentRoute: typeof KinerjaRoute
    }
    '/kinerja/my-assessments': {
      id: '/kinerja/my-assessments'
      path: '/my-assessments'
      fullPath: '/kinerja/my-assessments'
      preLoaderRoute: typeof KinerjaMyAssessmentsRouteImport
      parentRoute: typeof KinerjaRoute
    }
    '/kinerja/milestone-templates': {
      id: '/kinerja/milestone-templates'
      path: '/milestone-templates'
      fullPath: '/kinerja/milestone-templates'
      preLoaderRoute: typeof KinerjaMilestoneTemplatesRouteImport
      parentRoute: typeof KinerjaRoute
    }
    '/kinerja/metrics': {
      id: '/kinerja/metrics'
      path: '/metrics'
      fullPath: '/kinerja/metrics'
      preLoaderRoute: typeof KinerjaMetricsRouteImport
      parentRoute: typeof KinerjaRoute
    }
    '/kinerja/metric-weights': {
      id: '/kinerja/metric-weights'
      path: '/metric-weights'
      fullPath: '/kinerja/metric-weights'
      preLoaderRoute: typeof KinerjaMetricWeightsRouteImport
      parentRoute: typeof KinerjaRoute
    }
    '/kinerja/competencies': {
      id: '/kinerja/competencies'
      path: '/competencies'
      fullPath: '/kinerja/competencies'
      preLoaderRoute: typeof KinerjaCompetenciesRouteImport
      parentRoute: typeof KinerjaRoute
    }
    '/kinerja/assessments': {
      id: '/kinerja/assessments'
      path: '/assessments'
      fullPath: '/kinerja/assessments'
      preLoaderRoute: typeof KinerjaAssessmentsRouteImport
      parentRoute: typeof KinerjaRoute
    }
    '/rekrut/jobs/': {
      id: '/rekrut/jobs/'
      path: '/'
      fullPath: '/rekrut/jobs/'
      preLoaderRoute: typeof RekrutJobsIndexRouteImport
      parentRoute: typeof RekrutJobsRoute
    }
    '/rekrut/candidates/': {
      id: '/rekrut/candidates/'
      path: '/'
      fullPath: '/rekrut/candidates/'
      preLoaderRoute: typeof RekrutCandidatesIndexRouteImport
      parentRoute: typeof RekrutCandidatesRoute
    }
    '/kinerja/tasks/': {
      id: '/kinerja/tasks/'
      path: '/tasks'
      fullPath: '/kinerja/tasks/'
      preLoaderRoute: typeof KinerjaTasksIndexRouteImport
      parentRoute: typeof KinerjaRoute
    }
    '/rekrut/jobs/$jobId': {
      id: '/rekrut/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/rekrut/jobs/$jobId'
      preLoaderRoute: typeof RekrutJobsJobIdRouteImport
      parentRoute: typeof RekrutJobsRoute
    }
    '/rekrut/candidates/$candidateId': {
      id: '/rekrut/candidates/$candidateId'
      path: '/$candidateId'
      fullPath: '/rekrut/candidates/$candidateId'
      preLoaderRoute: typeof RekrutCandidatesCandidateIdRouteImport
      parentRoute: typeof RekrutCandidatesRoute
    }
    '/org/employees/$employeeId': {
      id: '/org/employees/$employeeId'
      path: '/employees/$employeeId'
      fullPath: '/org/employees/$employeeId'
      preLoaderRoute: typeof OrgEmployeesEmployeeIdRouteImport
      parentRoute: typeof OrgRoute
    }
    '/kinerja/templates/$templateId': {
      id: '/kinerja/templates/$templateId'
      path: '/$templateId'
      fullPath: '/kinerja/templates/$templateId'
      preLoaderRoute: typeof KinerjaTemplatesTemplateIdRouteImport
      parentRoute: typeof KinerjaTemplatesRoute
    }
    '/kinerja/assessments/$sessionId': {
      id: '/kinerja/assessments/$sessionId'
      path: '/$sessionId'
      fullPath: '/kinerja/assessments/$sessionId'
      preLoaderRoute: typeof KinerjaAssessmentsSessionIdRouteImport
      parentRoute: typeof KinerjaAssessmentsRoute
    }
    '/kinerja/tasks/sprints/$sprintId': {
      id: '/kinerja/tasks/sprints/$sprintId'
      path: '/tasks/sprints/$sprintId'
      fullPath: '/kinerja/tasks/sprints/$sprintId'
      preLoaderRoute: typeof KinerjaTasksSprintsSprintIdRouteImport
      parentRoute: typeof KinerjaRoute
    }
    '/kinerja/tasks/projects/$projectId': {
      id: '/kinerja/tasks/projects/$projectId'
      path: '/tasks/projects/$projectId'
      fullPath: '/kinerja/tasks/projects/$projectId'
      preLoaderRoute: typeof KinerjaTasksProjectsProjectIdRouteImport
      parentRoute: typeof KinerjaRoute
    }
    '/kinerja/psychometrics/$testId/take': {
      id: '/kinerja/psychometrics/$testId/take'
      path: '/$testId/take'
      fullPath: '/kinerja/psychometrics/$testId/take'
      preLoaderRoute: typeof KinerjaPsychometricsTestIdTakeRouteImport
      parentRoute: typeof KinerjaPsychometricsRoute
    }
    '/kinerja/psychometrics/$testId/edit': {
      id: '/kinerja/psychometrics/$testId/edit'
      path: '/$testId/edit'
      fullPath: '/kinerja/psychometrics/$testId/edit'
      preLoaderRoute: typeof KinerjaPsychometricsTestIdEditRouteImport
      parentRoute: typeof KinerjaPsychometricsRoute
    }
    '/kinerja/tasks/sprints/$sprintId_/summary': {
      id: '/kinerja/tasks/sprints/$sprintId_/summary'
      path: '/tasks/sprints/$sprintId/summary'
      fullPath: '/kinerja/tasks/sprints/$sprintId/summary'
      preLoaderRoute: typeof KinerjaTasksSprintsSprintIdSummaryRouteImport
      parentRoute: typeof KinerjaRoute
    }
  }
}

interface KinerjaAssessmentsRouteChildren {
  KinerjaAssessmentsSessionIdRoute: typeof KinerjaAssessmentsSessionIdRoute
}

const KinerjaAssessmentsRouteChildren: KinerjaAssessmentsRouteChildren = {
  KinerjaAssessmentsSessionIdRoute: KinerjaAssessmentsSessionIdRoute,
}

const KinerjaAssessmentsRouteWithChildren =
  KinerjaAssessmentsRoute._addFileChildren(KinerjaAssessmentsRouteChildren)

interface KinerjaPsychometricsRouteChildren {
  KinerjaPsychometricsTestIdEditRoute: typeof KinerjaPsychometricsTestIdEditRoute
  KinerjaPsychometricsTestIdTakeRoute: typeof KinerjaPsychometricsTestIdTakeRoute
}

const KinerjaPsychometricsRouteChildren: KinerjaPsychometricsRouteChildren = {
  KinerjaPsychometricsTestIdEditRoute: KinerjaPsychometricsTestIdEditRoute,
  KinerjaPsychometricsTestIdTakeRoute: KinerjaPsychometricsTestIdTakeRoute,
}

const KinerjaPsychometricsRouteWithChildren =
  KinerjaPsychometricsRoute._addFileChildren(KinerjaPsychometricsRouteChildren)

interface KinerjaTemplatesRouteChildren {
  KinerjaTemplatesTemplateIdRoute: typeof KinerjaTemplatesTemplateIdRoute
}

const KinerjaTemplatesRouteChildren: KinerjaTemplatesRouteChildren = {
  KinerjaTemplatesTemplateIdRoute: KinerjaTemplatesTemplateIdRoute,
}

const KinerjaTemplatesRouteWithChildren =
  KinerjaTemplatesRoute._addFileChildren(KinerjaTemplatesRouteChildren)

interface KinerjaRouteChildren {
  KinerjaAssessmentsRoute: typeof KinerjaAssessmentsRouteWithChildren
  KinerjaCompetenciesRoute: typeof KinerjaCompetenciesRoute
  KinerjaMetricWeightsRoute: typeof KinerjaMetricWeightsRoute
  KinerjaMetricsRoute: typeof KinerjaMetricsRoute
  KinerjaMilestoneTemplatesRoute: typeof KinerjaMilestoneTemplatesRoute
  KinerjaMyAssessmentsRoute: typeof KinerjaMyAssessmentsRoute
  KinerjaOrgLevelsRoute: typeof KinerjaOrgLevelsRoute
  KinerjaPositionsRoute: typeof KinerjaPositionsRoute
  KinerjaPsychometricsRoute: typeof KinerjaPsychometricsRouteWithChildren
  KinerjaTemplatesRoute: typeof KinerjaTemplatesRouteWithChildren
  KinerjaTrainingCatalogueRoute: typeof KinerjaTrainingCatalogueRoute
  KinerjaIndexRoute: typeof KinerjaIndexRoute
  KinerjaTasksIndexRoute: typeof KinerjaTasksIndexRoute
  KinerjaTasksProjectsProjectIdRoute: typeof KinerjaTasksProjectsProjectIdRoute
  KinerjaTasksSprintsSprintIdRoute: typeof KinerjaTasksSprintsSprintIdRoute
  KinerjaTasksSprintsSprintIdSummaryRoute: typeof KinerjaTasksSprintsSprintIdSummaryRoute
}

const KinerjaRouteChildren: KinerjaRouteChildren = {
  KinerjaAssessmentsRoute: KinerjaAssessmentsRouteWithChildren,
  KinerjaCompetenciesRoute: KinerjaCompetenciesRoute,
  KinerjaMetricWeightsRoute: KinerjaMetricWeightsRoute,
  KinerjaMetricsRoute: KinerjaMetricsRoute,
  KinerjaMilestoneTemplatesRoute: KinerjaMilestoneTemplatesRoute,
  KinerjaMyAssessmentsRoute: KinerjaMyAssessmentsRoute,
  KinerjaOrgLevelsRoute: KinerjaOrgLevelsRoute,
  KinerjaPositionsRoute: KinerjaPositionsRoute,
  KinerjaPsychometricsRoute: KinerjaPsychometricsRouteWithChildren,
  KinerjaTemplatesRoute: KinerjaTemplatesRouteWithChildren,
  KinerjaTrainingCatalogueRoute: KinerjaTrainingCatalogueRoute,
  KinerjaIndexRoute: KinerjaIndexRoute,
  KinerjaTasksIndexRoute: KinerjaTasksIndexRoute,
  KinerjaTasksProjectsProjectIdRoute: KinerjaTasksProjectsProjectIdRoute,
  KinerjaTasksSprintsSprintIdRoute: KinerjaTasksSprintsSprintIdRoute,
  KinerjaTasksSprintsSprintIdSummaryRoute:
    KinerjaTasksSprintsSprintIdSummaryRoute,
}

const KinerjaRouteWithChildren =
  KinerjaRoute._addFileChildren(KinerjaRouteChildren)

interface OrgRouteChildren {
  OrgIndexRoute: typeof OrgIndexRoute
  OrgEmployeesEmployeeIdRoute: typeof OrgEmployeesEmployeeIdRoute
}

const OrgRouteChildren: OrgRouteChildren = {
  OrgIndexRoute: OrgIndexRoute,
  OrgEmployeesEmployeeIdRoute: OrgEmployeesEmployeeIdRoute,
}

const OrgRouteWithChildren = OrgRoute._addFileChildren(OrgRouteChildren)

interface RekrutCandidatesRouteChildren {
  RekrutCandidatesCandidateIdRoute: typeof RekrutCandidatesCandidateIdRoute
  RekrutCandidatesIndexRoute: typeof RekrutCandidatesIndexRoute
}

const RekrutCandidatesRouteChildren: RekrutCandidatesRouteChildren = {
  RekrutCandidatesCandidateIdRoute: RekrutCandidatesCandidateIdRoute,
  RekrutCandidatesIndexRoute: RekrutCandidatesIndexRoute,
}

const RekrutCandidatesRouteWithChildren =
  RekrutCandidatesRoute._addFileChildren(RekrutCandidatesRouteChildren)

interface RekrutJobsRouteChildren {
  RekrutJobsJobIdRoute: typeof RekrutJobsJobIdRoute
  RekrutJobsIndexRoute: typeof RekrutJobsIndexRoute
}

const RekrutJobsRouteChildren: RekrutJobsRouteChildren = {
  RekrutJobsJobIdRoute: RekrutJobsJobIdRoute,
  RekrutJobsIndexRoute: RekrutJobsIndexRoute,
}

const RekrutJobsRouteWithChildren = RekrutJobsRoute._addFileChildren(
  RekrutJobsRouteChildren,
)

interface RekrutRouteChildren {
  RekrutCandidatesRoute: typeof RekrutCandidatesRouteWithChildren
  RekrutJobsRoute: typeof RekrutJobsRouteWithChildren
  RekrutPipelineRoute: typeof RekrutPipelineRoute
  RekrutIndexRoute: typeof RekrutIndexRoute
}

const RekrutRouteChildren: RekrutRouteChildren = {
  RekrutCandidatesRoute: RekrutCandidatesRouteWithChildren,
  RekrutJobsRoute: RekrutJobsRouteWithChildren,
  RekrutPipelineRoute: RekrutPipelineRoute,
  RekrutIndexRoute: RekrutIndexRoute,
}

const RekrutRouteWithChildren =
  RekrutRoute._addFileChildren(RekrutRouteChildren)

interface WawasanRouteChildren {
  Wawasan9boxRoute: typeof Wawasan9boxRoute
  WawasanIndexRoute: typeof WawasanIndexRoute
}

const WawasanRouteChildren: WawasanRouteChildren = {
  Wawasan9boxRoute: Wawasan9boxRoute,
  WawasanIndexRoute: WawasanIndexRoute,
}

const WawasanRouteWithChildren =
  WawasanRoute._addFileChildren(WawasanRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  DashboardRoute: DashboardRoute,
  IdpRoute: IdpRoute,
  KinerjaRoute: KinerjaRouteWithChildren,
  KinerjaProductRoute: KinerjaProductRoute,
  LoginRoute: LoginRoute,
  OrgRoute: OrgRouteWithChildren,
  ProfileRoute: ProfileRoute,
  RekrutRoute: RekrutRouteWithChildren,
  RekrutProductRoute: RekrutProductRoute,
  ReportsRoute: ReportsRoute,
  SuperadminRoute: SuperadminRoute,
  WawasanRoute: WawasanRouteWithChildren,
  WawasanProductRoute: WawasanProductRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
